<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">DEDICATION:</p>
<p class="ded1">FOR ALL MY ELEVEN O’CLOCK FRIENDS, WITH LOVE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?75f92fb0